import React, { useEffect, useState } from "react";
import { DashboardManagerFilter } from "../../../model/dashboard-manger-filter";
import { BaseList } from "../../../../../component/list/base-list";
import { columns } from "./session-attendance-stats-list-column-definition";
import { getSessionAttendanceStats } from "../../../service/dashboard-manager-service";
import { SessionAttendanceStats, SessionAttendanceSummary } from "../../../model/session-attendance-stats";
import { Box, Chip, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Dayjs } from "dayjs";

const storageKey = "DASHBOARD_MANAGER_SESSION_ATTENDANCE"

export default function SessionAttendanceStatsList({
    filter
}: {
    filter: DashboardManagerFilter
}) {
    const [loading, setLoading] = useState(false);
    const [attendees, setAttendees] = useState<SessionAttendanceStats[]>([]);
    const [summary, setSummary] = useState<SessionAttendanceSummary | null>(null);
    const [roleFilter, setRoleFilter] = useState<string>('');
    const [from, setFrom] = useState<Dayjs | null>(null);
    const [to, setTo] = useState<Dayjs | null>(null);

    useEffect(() => {
        if (filter.cohortId !== undefined && from !== null && to !== null && to.diff(from, 'day') >= 0) {
            setLoading(true);
            getSessionAttendanceStats(
                filter.cohortId,
                from.format('YYYY-MM-DD'),
                to.format('YYYY-MM-DD'),
                roleFilter || undefined
            ).then(result => {
                setSummary(result);
                setAttendees(result.attendees);
                setLoading(false);
            });
        } else {
            setAttendees([]);
            setSummary(null);
        }
    }, [filter.cohortId, from, to, roleFilter]);

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                <FormControl size="small" sx={{ minWidth: 150 }}>
                    <InputLabel>Role</InputLabel>
                    <Select value={roleFilter} label="Role" onChange={(e) => setRoleFilter(e.target.value)}>
                        <MenuItem value="">All Roles</MenuItem>
                        <MenuItem value="Guide">Guides</MenuItem>
                        <MenuItem value="Coach">Coaches</MenuItem>
                        <MenuItem value="Explorer">Explorers</MenuItem>
                    </Select>
                </FormControl>
                {summary && (
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Chip label={`${summary.totalSessions} sessions`} size="small" color="primary" variant="outlined" />
                        <Chip label={`${summary.totalHours}h total`} size="small" color="secondary" variant="outlined" />
                        <Chip label={`${attendees.reduce((sum, a) => sum + a.totalHours, 0).toFixed(1)}h attended`} size="small" color="success" variant="outlined" />
                        <Chip label={`${summary.totalGuides} guides`} size="small" variant="outlined" />
                        <Chip label={`${summary.totalCoaches} coaches`} size="small" variant="outlined" />
                        <Chip label={`${summary.totalExplorers} explorers`} size="small" variant="outlined" />
                    </Box>
                )}
            </Box>
            <BaseList
                storageKey={storageKey}
                rows={attendees}
                columns={columns}
                loading={loading}
                localeText={{ noRowsLabel: "No session attendance data" }}
                getRowId={(row) => `${row?.actorId}-${row?.sessionRole}`}
                disableRowSelectionOnClick
                from={from}
                to={to}
                setFrom={setFrom}
                setTo={setTo}
                exportName={`session_attendance_${filter.cohortId}`}
            />
        </React.Fragment>
    );
}
